<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Confirmation
    </div>
    <div class="card-body">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col" style="width: 5px;">#</th>
                    <th>View</th>
                    <th style="width: 100px;">Approval Status</th>
                    <th style="width: 100px;">Joining Date</th>
                    <th style="width: 140px;">Confirmation Date</th>
                    <th style="width: 150px;">Confirmation Status</th>
                    <th style="width: 200px;">Branch</th>
                    <th style="width: 300px;"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.EmpType) == 'back'}">Client Location
                    </th>
                    <!-- <th style="width: 300px;">{{this.common.ToLowerCase(this.Filter.EmpType) == 'front'?'Client
                        Location':this.common.ToLowerCase(this.Filter.EmpType) ==
                        'back'?'Branch Name':''}}</th> -->
                    <th style="width: 120px;">Working Status</th>
                    <!-- <th style="width: 140px;">Probation End Date</th> -->
                    <th style="width: 300px;">Initiator Name</th>
                    <th style="width: 120px;">Initiated Date</th>
                    <th style="width: 300px;">Intimation Name</th>
                    <th style="width: 120px;">Initimation Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TableData of TableDatas; let i = index">
                    <th scope="row">{{ i + 1 }}</th>
                    <td style="width: 5px;">
                        <div style="width: 80px;"
                            *ngIf="this.common.ToLowerCase(TableData['ApprovalStatus']) == 'initiated'"><button
                                type="button" class="btn btn-outline-primary btn-sm"
                                [routerLink]="['/request/questionnaire/add/',TableData['ESS_EmployeeConfirmationDetailsID']]"><i
                                    class="bi bi-info-square me-1"></i>View</button></div>

                        <div style="width: 80px;"
                            *ngIf="this.common.ToLowerCase(TableData['ApprovalStatus']) != 'initiated'"><button
                                type="button" class="btn btn-outline-primary btn-sm"
                                [routerLink]="['/request/questionnaire/detail/',TableData['ESS_EmployeeConfirmationDetailsID']]"><i
                                    class="bi bi-info-square me-1"></i>View</button></div>
                    </td>
                    <td><span class="badge"
                            [ngClass]="{'success':common.ToLowerCase(StatusReplace(TableData['ApprovalStatus'],TableData['IsTerminated'])) == 'approved', 'warning':common.ToLowerCase(StatusReplace(TableData['ApprovalStatus'],TableData['IsTerminated'])) == 'pending','danger':common.ToLowerCase(StatusReplace(TableData['ApprovalStatus'],TableData['IsTerminated'])) == 'rejected'}">{{StatusReplace(TableData['ApprovalStatus'],TableData['IsTerminated'])}}</span>
                    </td>
                    <td>
                        <div style="width: 100px;">{{TableData['JoiningDate']}}</div>
                    </td>
                    <td>
                        <div style="width: 140px;">{{TableData['ConfirmationDate']}}</div>
                    </td>
                    <td>
                        <div style="width: 150px;">{{TableData['IsEmpConfirmed']}}</div>
                    </td>
                    <td style="width: 200px;">
                        <div style="width: 200px;">{{TableData['BranchName']}}</div>
                    </td>
                    <td style="width: 300px;"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.EmpType) == 'back'}">
                        <div style="width: 300px;">{{TableData['ClientLocation']}}</div>
                    </td>
                    <!-- <td>
                        <div style="width: 300px;">{{this.common.ToLowerCase(this.Filter.EmpType) ==
                            'front'?TableData['ClientLocation']:this.common.ToLowerCase(this.Filter.EmpType) ==
                            'back'?TableData['BranchName']:''}}</div>
                    </td> -->
                    <td>
                        <div style="width: 120px;">{{TableData['WorkingStatus']}}</div>
                    </td>
                    <!-- <td>
                        <div style="width: 140px;">{{TableData['ProbationDate']}}</div>
                    </td>-->
                    <td>
                        <div style="width: 300px;">{{TableData['InitiatorName']}}</div>
                    </td>
                    <td>
                        <div style="width: 120px;">{{TableData['InitiatedDate']}}</div>
                    </td>
                    <td>
                        <div style="width: 300px;">{{TableData['IntimationName']}}</div>
                    </td>
                    <td>
                        <div style="width: 120px;">{{TableData['InitimationOn']}}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>